<template>
  <div class="signaturePage">
    <div class="label">Signature <span class="redcolor">*</span></div>
    <div class="canvasbox">

      <canvas ref="signatureCanvas" class="signaturPad " style="z-index: 1;">
      </canvas>   

      <div class="flex_pc ">
        <div class="btnbox ">
          <div class="btn" @click="clearCanvas">Clear</div>  
         
        </div>
      </div> 
 
    </div>
    <div class="flex_mobile" style="margin-top:0.5rem;">
    <div class="btnbox ">
          <div class="btn" @click="clearCanvas">Clear</div>  
          <!----<div class="btn bc" @click="saveSignature">{{btnTitle}}</div>-->
        </div>
      </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import { localDriver } from '@/utils/localDriver'

export default {
  props: ['signidx'],
  emits:['initCode','savePDF','mark'],
  data () {
    return {
      btnTitle:'Save',
      signaturePad:null,
      code:0,
      initialSignature:{},
    }
  },
  watch:{
    signaturePad:{
      handler(newValue, oldValue) {
        this.btnTitle='Save and Send Code';
        this.$emit('initCode');
      },
      deep: true
    },
    signidx:{
      handler(newValue, oldValue) {
        // this.btnTitle='Save';
        this.clearCanvas();
      },
      deep: true
    },
  },
  mounted() {
    const canvas = document.querySelector("canvas")
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    canvas.style.zIndex="2" 
    this.$nextTick(() => {
      this.signaturePad = new SignaturePad(canvas)
      this.signaturePad.addEventListener("beginStroke", () => {
      }, { once: true })
      this.$emit('mark',{signPad:this.signaturePad,canvas:canvas})
      this.clearCanvas()
    })
  },
  methods: {
    getSignatureData() {
      const canvas = document.querySelector("canvas")
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (canvas) {
        const dataURL = canvas.toDataURL('image/png')
        this.$emit('saveSignatureImage', dataURL)
      }
    },
    drawRepeatedDateWatermarks()
    {
	    const canvas = document.querySelector("canvas")
      canvas.height = 120
       if (document.documentElement.clientWidth < 750) {
        canvas.height = 180
        canvas.style.height = '100%'
       }
       else
       {
        canvas.width = 600
        canvas.style.width = '80%'
       }   
      const context = canvas.getContext('2d',{willReadFrequently: true})
      context.font = '24px Arial'
      context.fillStyle = 'rgba(0, 0, 0, 0.1)' 
      context.textAlign = 'center'
      context.textBaseline = 'middle'
      const currentDate = new Date()
      const dateString = currentDate.toDateString()
      const rows = Math.ceil(canvas.height / 50) 
      var x = canvas.width / 2 
      for (let row = 0; row < rows; row++) {
          const y = row * 50 + 25
          context.fillText(dateString, x, y)
      }
    },
    clearCanvas() {
      this.signaturePad.clear();
      this.drawRepeatedDateWatermarks()
    },
    saveSignature(){
      this.$emit('savePDF')
    },
  },
};
</script>

<style lang="scss" scoped>
/* 可以添加一些组件特定的样式 */
.flex_mobile {display: none;}
.flex_pc {display:block;}
.signaturePage .canvasbox{
  width:100%;
  border:1px solid #e3e3e3;
  text-align: center;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  flex-direction: row;
}
.signaturePage .signaturPad{
  padding:3px;
  width:100%;
}
.signaturePage .action{
  padding:3px;
  width:8%;
  vertical-align: bottom;
}
.signaturePage .btnbox{
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
}
.signaturePage .btnbox .btn{
  color:#fff;
  align-items: center;
  background-color: #67a160;
  border-radius: 5px;
  justify-content: center;
  padding: 8px 10px 8px;
  position: relative;
  font-size:1.7333rem;
  font-weight: 500;
}
.signaturePage .label{
  font-size:2.1667rem;
  font-weight: 700;
  height: 30px;
}
.signaturePage .redcolor{
  color:#f00;
}

/* 移动端  */
@media screen and (max-width:750px) {  

  .signaturePage .signaturPad{

  width: 100% !important;;

}
  .signaturePage .label{margin-bottom:0.5rem;}
  .flex_mobile {display:flex;width:100%}
  .flex_pc {display:none;}
  .signaturePage .btnbox .btn{
  width:19rem;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  display:flex;
}
}
</style>


